module.exports = __webpack_public_path__ + "img/quanjude.4b21a6aa.webp";